import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/TiktokSpecialCampaignReportGrid.graphql';
import { Query, QuerytiktokSpecialCampaignReportGridArgs } from '../../__generated__/globalTypes';

export const useTiktokSpecialCampaignReportGridQuery = (
  options?: QueryHookOptions<Query, QuerytiktokSpecialCampaignReportGridArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerytiktokSpecialCampaignReportGridArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useTiktokSpecialCampaignReportGridLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerytiktokSpecialCampaignReportGridArgs>
): QueryResult<Query, QuerytiktokSpecialCampaignReportGridArgs> & {
  getTiktokSpecialCampaignReportGrid: LazyQueryExecFunction<Query, QuerytiktokSpecialCampaignReportGridArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getTiktokSpecialCampaignReportGrid, result] = useLazyQuery<Query, QuerytiktokSpecialCampaignReportGridArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getTiktokSpecialCampaignReportGrid, ...result };
};

export const useTiktokSpecialCampaignReportGridPromiseQuery = () => {
  const client = useApolloClient();

  const getTiktokSpecialCampaignReportGrid = useCallback(
    (options?: Omit<QueryOptions<QuerytiktokSpecialCampaignReportGridArgs, Query>, 'query'>) =>
      client.query<Query, QuerytiktokSpecialCampaignReportGridArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getTiktokSpecialCampaignReportGrid };
};
// Suspense Query Hooks
export const useTiktokSpecialCampaignReportGridSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerytiktokSpecialCampaignReportGridArgs>
) => {
  const result = useSuspenseQuery<Query, QuerytiktokSpecialCampaignReportGridArgs>(QUERY, {
    ...options
  });

  return result;
};
